export const gt = (key) => {
    try {
        return window.lt[key.toUpperCase()] ? window.lt[key.toUpperCase()] : key
    } catch (err) {
        return key
    }
}

window.gt = gt;